import React, { useCallback } from 'react';
import { apiHolder as api } from 'api';
import debounce from 'lodash/debounce';
import LxEditor from '@web-common/components/UI/LxEditor/LxEditor';
import toast from '@web-common/components/UI/Message/SiriusMessage';
export const MailTemplateEditor = ({ getEditorInstance, changeMailContent, onEditorChange, placeholder = '' }) => {
    const FileApi = api.api.getFileApi();
    const imagesUploadHandler = (blobInfo, succFun, failFun) => {
        let file = blobInfo.blob();
        if (Object.prototype.toString.call(blobInfo.blob()) !== '[object File]') {
            file = new File[blobInfo.blob()]();
        }
        FileApi.uploadFile({
            fileName: file.name,
            file,
            fileSourceType: file.type,
            fileSize: file.size,
        })
            .then(({ data }) => {
            if (data.code !== 200) {
                if (data.message === '系统检测为风险文件，上传失败') {
                    toast.error({ content: '系统检测为风险文件，上传失败' });
                }
                return Promise.reject(data);
            }
            succFun({ url: data.data.url, originUrl: data.data.url });
        })
            .catch(() => {
            failFun();
        });
    };
    const init = {
        placeholder,
        setup: ed => {
            ed.on('blur', () => {
                changeMailContent();
            });
        },
        init_instance_callback: ed => {
            getEditorInstance(ed);
        },
        plugins: [
            'advlist autolink lists link lximg image print preview fullpage lxinputdirection autoresize',
            'searchreplace visualblocks fullscreen nonbreaking lxsignature',
            'media table paste code lxuploadattachment lxmailformat lxcontact lxformatpainter',
        ],
        images_upload_handler: imagesUploadHandler,
    };
    const onEditorChangeDebounce = useCallback(debounce((val, cb) => {
        if (cb) {
            cb(val);
        }
    }, 500), []);
    return React.createElement(LxEditor, { uniqueClass: "mail-template-editor", init: init, onEditorChange: (val) => onEditorChangeDebounce(val, onEditorChange) });
};
